<template>
    <div>
        <h1>Student QR</h1>
        <p>Student ID: {{ studentId }}</p>

        <div class="showQR">

        </div>

    </div>
</template>

<script>
    export default {
        name: 'StudentAddItem',

        props: {
        studentId: {
            type: Number,
            required: true
        },
    },

        
    }
</script>

<style lang="scss" scoped>

</style>